import * as types from '../constants';

export function loadPlaybooks() {
  return {
    type: types.LOAD_PLAYBOOKS,
  };
}

export function loadPlaybooksLogs(uuid) {
  return {
    type: types.LOAD_PLAYBOOKS_LOGS,
    uuid,
  };
}

export function updatePlaybooks(data, uuid) {
  return {
    type: types.UPDATE_PLAYBOOKS,
    data,
    uuid,
  };
}

export function savePlaybooks(data) {
  return {
    type: types.SAVE_PLAYBOOKS,
    data,
  };
}

export function deletePlaybooks(uuid) {
  return {
    type: types.DELETE_PLAYBOOKS,
    uuid,
  };
}

export function runPlaybooks(uuid) {
  return {
    type: types.RUN_PLAYBOOKS,
    uuid,
  };
}
